import useUpdateRecordNameTemplate from "api/api-hooks/modules/useUpdateRecordNameTemplate";
import AppPageHeader from "components/Headers/AppPageHeader";
import EditSaveButton from "elements/EditSaveButton";
import { useEffect, useMemo, useState } from "react";
import { SelectPicker } from "rsuite";
import { newToastEvent } from "utils/ToastUtil";
import DisplayFieldSection from "./DisplayFieldSection";
import FieldSettingsButton from "./FieldSettingsButton";

const RecordNameImage = ({ module, customSave }) => {
  const [isEditing, setIsEditing] = useState(!!customSave);
  const [imageField, setImageField] = useState("");
  const savedImageField = module?.Templates?.RecordDetailView?.ImageField ?? "";

  const {
    updateRecordNameTemplate,
    updatingRecordNameTemplate,
    updateRecordNameTemplateError,
  } = useUpdateRecordNameTemplate();

  useEffect(() => {
    setImageField(savedImageField);
  }, [savedImageField]);

  const imageFields = useMemo(() => {
    if (!Array.isArray(module?.Fields)) return [];

    return module.Fields.filter((f) => f?.FieldType === "Image");
  }, [module?.Fields]);

  return (
    <>
      <div className="py-3 mb-3 border-bottom border-lighter">
        <AppPageHeader
          size="sm"
          title={"Record Name Image"}
          description={`Include an image with the Record Name, using Image`}
          titleBreakpoints={{ xs: 6, sm: "auto" }}
          actionsBreakpoints={{ xs: 6, sm: "auto" }}
          actionClass="d-flex justify-content-end"
          customContent={
            !customSave && (
              <EditSaveButton
                isEditing={isEditing}
                setIsEditing={setIsEditing}
                onCancel={onCancel}
                onSave={handleSave}
                isSubmitting={updatingRecordNameTemplate}
              />
            )
          }
        />
      </div>
      {isEditing ? (
        imageFields?.length < 1 ? (
          <div className="font-weight-500 text-sm bg-superlight p-2 border rounded-sm">
            This Data Source doesn&apos;t have any Image Fields. Get started by
            adding a Field of type Image.
            {!customSave && (
              <>
                <br />
                <FieldSettingsButton module={module} />
              </>
            )}
          </div>
        ) : (
          <SelectPicker
            block
            placeholder="Select Image Field"
            data={imageFields}
            labelKey="Name"
            valueKey="APIName"
            value={imageField}
            disabledItemValues={["_RecordName", "id"]}
            onClean={() => {
              customSave && customSave({ recordNameImage: "" });
              setImageField("");
            }}
            searchable={imageFields?.length > 5}
            onChange={(f) => {
              customSave && customSave({ recordNameImage: f });
              setImageField(f);
            }}
            preventOverflow
          />
        )
      ) : (
        <DisplayFieldSection field={savedImageField} />
      )}
    </>
  );

  function onCancel() {
    setImageField(savedImageField);
  }

  function handleSave() {
    updateRecordNameTemplate({
      moduleAPIName: module.APIName,
      recordNameImage: imageField,
      onSuccess: () => {
        setIsEditing(false);
        newToastEvent("success", "Successfully saved Record Name Template");
      },
    });
  }
};

export default RecordNameImage;
